import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLastViewedProducts } from '../../hooks/useLastViewedProducts';
import Item from '../Item/item';
import { ProductSkeleton } from '../UI';
import {
  filterListableProducts,
  getProductImageUrl,
  getProductId,
  getProductName,
  getProductPrices,
  isProductInStock,
} from '../../utils/helpers';
import './RecentlyViewed.css';
import { Clock } from 'lucide-react';

const RecentlyViewed = ({ limit = 8 }) => {
  const { t } = useTranslation('common');
  const { data: products, isLoading } = useLastViewedProducts(limit);

  if (isLoading) {
    return (
      <section className="recently-viewed-section">
        <div className="recently-viewed-container">
          <div className="recently-viewed-header">
            <Clock size={24} />
            <h2 className="section-title">{t('recentlyViewed', { defaultValue: 'Recently Viewed' })}</h2>
          </div>
          <div className="products-grid">
            <ProductSkeleton count={limit} />
          </div>
        </div>
      </section>
    );
  }

  const listable = filterListableProducts(products || []);

  if (!listable.length) {
    return null;
  }

  return (
    <section className="recently-viewed-section">
      <div className="recently-viewed-container">
        <div className="recently-viewed-header">
          <Clock size={24} />
          <h2 className="section-title">{t('recentlyViewed', { defaultValue: 'Recently Viewed' })}</h2>
        </div>
        <div className="products-grid">
          {listable.map((product, i) => {
            const { price, comparePrice, fromPrice } = getProductPrices(product);
            return (
              <Item
                key={getProductId(product) || i}
                id={getProductId(product)}
                image={getProductImageUrl(product)}
                name={getProductName(product)}
                newPrice={price}
                oldPrice={comparePrice}
                fromPrice={fromPrice}
                sold={product.sold || product.salesCount || 0}
                rating={product.averageRating || product.rating || 4.5}
                shipping={product.freeShipping ? t('freeShipping') : t('standardShipping')}
                inStock={isProductInStock(product)}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;

